import { shape, string } from 'prop-types';
import imageProps from './imageProps';

export default {
    name: string,
    photo: shape(imageProps)
};
